import { render, staticRenderFns } from "./BookingButtons.vue?vue&type=template&id=10463154"
import script from "./BookingButtons.vue?vue&type=script&lang=js"
export * from "./BookingButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports